/**
 * Created by Jonas Wålekvist on 2017-11-06.
 */
import {ColossalSymbolInfo} from "../server/data/DungeonQuestParsedGameData";
import {StateMatrix} from "../../utils/StateMatrix";
import {WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {DungeonQuestSymbols} from "../DungeonQuestGameConfig";

export class DungeonQuestHelper {


    public static isMatchingLowMidPair(low:string, mid:string):boolean {
        return low.substr(-1) == mid.substr(-1) && low != mid;
    }

    public static isLowWin(symbol:string):boolean {
        return symbol == "L1" || symbol == "L2" || symbol == "L3" || symbol == "L4"
    }

    public static isMidWin(symbol:string):boolean {
        return symbol == "M1" || symbol == "M2" || symbol == "M3" || symbol == "M4"
    }

    public static isWild(symbol:string):boolean {
        return symbol == "W";
    }

    public static getDarkenColor():number {
        return 0x201832;
    }

    public static getSymbolColor(symbolName:string):number {

        if(symbolName == DungeonQuestSymbols.M1 || symbolName == DungeonQuestSymbols.L1) {
            return 0x71ff00;
        }
        if(symbolName == DungeonQuestSymbols.M2 || symbolName == DungeonQuestSymbols.L2) {
            return 0xffdd00;
        }
        if(symbolName == DungeonQuestSymbols.M3 || symbolName == DungeonQuestSymbols.L3) {
            return 0x0caaff;
        }
        if(symbolName == DungeonQuestSymbols.M4 || symbolName == DungeonQuestSymbols.L4) {
            return 0xec0b59;
        }
        if(symbolName == DungeonQuestSymbols.S) {
            return 0x7a43a2;
        }
        if(symbolName == DungeonQuestSymbols.W || symbolName == DungeonQuestSymbols.W_STICKY) {
            return 0xffffff;
        }


        return 0xffffff;

    }

    public static createSquareDistanceMatrix(data:ColossalSymbolInfo, minDistance:number = 0):StateMatrix<number> {
        const distanceMatrix = new StateMatrix<number>(5, 7, [0, 6], 0);

        for(let reelIndex:number = 0; reelIndex < 5; reelIndex++) {
            for(let symbolIndex:number = 0; symbolIndex < 7; symbolIndex++) {
                let distanceX = 0;
                if(symbolIndex < data.position[1]) {
                    distanceX = Math.abs(symbolIndex - data.position[1]);
                } else if(symbolIndex >= data.position[1] + data.size) {
                    distanceX = Math.abs(symbolIndex - (data.position[1] + data.size - 1));
                }

                let distanceY = 0;
                if(reelIndex < data.position[0]) {
                    distanceY = Math.abs(reelIndex - data.position[0]);
                } else if(reelIndex >= data.position[0] + data.size) {
                    distanceY = Math.abs(reelIndex - (data.position[0] + data.size - 1));
                }

                const distance:number = Math.max(minDistance, distanceX + distanceY);
                distanceMatrix.setStateAt(reelIndex, symbolIndex, distance);
            }
        }
        return distanceMatrix;
    }

    static getSymbolWindUpDuration(winTypeIndex:number) {
        switch(winTypeIndex) {
            case 1:
                return 0.5;
            case 2:
                return 1;
            case 3:
                return 1.5;
            case 4:
                return 2.5;
            default:
                return 0

        }
    }

    static getWinTypeIndex(winType:WinRatioType):number {
        switch(winType) {
            case WinRatioType.TINY:
            case WinRatioType.SMALL:
                return 1;
            case WinRatioType.MEDIUM:
                return 2;
            case WinRatioType.LARGE:
                return 3;
            case WinRatioType.BIG_WIN:
            case WinRatioType.MEGA_WIN:
            case WinRatioType.SUPER_MEGA_WIN:
                return 4;
            default:
                return 0

        }
    }
}